import React from 'react'
import { Card, Col, Row, Statistic, Typography, Spin, message, Button, Space } from 'antd'
import { UserOutlined, ShoppingCartOutlined, ShopOutlined, TransactionOutlined, CheckCircleOutlined, ReloadOutlined } from '@ant-design/icons'
import { apiUrl } from '../../config/api'
import { formatAmount } from '../../utils/amount'

const { Title } = Typography

export default function AdminStats() {
    const [stats, setStats] = React.useState(null)
    const [loading, setLoading] = React.useState(true)

    const fetchStats = React.useCallback(async () => {
        setLoading(true)
        try {
            const secret = localStorage.getItem('x-auth-secret')
            const resp = await fetch(apiUrl('/api/admin/stats'), {
                headers: {
                    'Accept': 'application/json',
                    'x-auth-secret': secret || ''
                }
            })
            if (!resp.ok) throw new Error('فشل في جلب الإحصائيات')
            const data = await resp.json()
            setStats(data)
        } catch (e) {
            console.error(e)
            message.error(e.message)
        } finally {
            setLoading(false)
        }
    }, [])

    React.useEffect(() => {
        fetchStats()
    }, [fetchStats])

    if (loading && !stats) {
        return <div style={{ textAlign: 'center', padding: '100px' }}><Spin size="large" /></div>
    }

    return (
        <div style={{ maxWidth: 1000, margin: '40px auto', padding: '0 16px', direction: 'rtl' }}>
            <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
                <Title level={2} style={{ margin: 0 }}>إحصائيات النظام</Title>
                <Button icon={<ReloadOutlined />} onClick={fetchStats} loading={loading}>تحديث</Button>
            </Space>

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                    <Card bordered={false} hoverable>
                        <Statistic
                            title="إجمالي المبيعات (بدون توصيل)"
                            value={stats?.totalSales || 0}
                            formatter={(v) => formatAmount(v)}
                            prefix={<TransactionOutlined />}
                            valueStyle={{ color: '#1890ff' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Card bordered={false} hoverable>
                        <Statistic
                            title="إجمالي الأرباح"
                            value={stats?.totalRevenue || 0}
                            formatter={(v) => formatAmount(v)}
                            prefix={<TransactionOutlined />}
                            valueStyle={{ color: '#fa8c16' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <Card bordered={false} hoverable>
                        <Statistic
                            title="إجمالي الأرباح المحصلة"
                            value={stats?.collectedRevenue || 0}
                            formatter={(v) => formatAmount(v)}
                            prefix={<CheckCircleOutlined />}
                            valueStyle={{ color: '#52c41a' }}
                        />
                    </Card>
                </Col>

                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} hoverable>
                        <Statistic
                            title="إجمالي المستخدمين"
                            value={stats?.totalUsers || 0}
                            prefix={<UserOutlined />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} hoverable>
                        <Statistic
                            title="إجمالي الطلبات"
                            value={stats?.totalOrders || 0}
                            prefix={<ShoppingCartOutlined />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} hoverable>
                        <Statistic
                            title="عدد المتاجر"
                            value={stats?.totalShops || 0}
                            prefix={<ShopOutlined />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} hoverable>
                        <Statistic
                            title="عدد المنتجات المسعرة"
                            value={stats?.totalItems || 0}
                            prefix={<ShopOutlined />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={12}>
                    <Card bordered={false} hoverable>
                        <Statistic
                            title="زوار الموقع اليوم"
                            value={stats?.uniqueVisitorsToday || 0}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#eb2f96' }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={12}>
                    <Card bordered={false} hoverable>
                        <Statistic
                            title="إجمالي زوار الموقع"
                            value={stats?.uniqueVisitorsAllTime || 0}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#722ed1' }}
                        />
                    </Card>
                </Col>
            </Row>

            <Card style={{ marginTop: 24 }}>
                <Typography.Paragraph type="secondary">
                    * يتم حساب الأرباح بناءً على الفرق بين سعر البيع للعميل وتكلفة المتجر المسجلة في السجلات المالية.
                    يتم استثناء رسوم التوصيل من هذه الحسابات حالياً.
                </Typography.Paragraph>
            </Card>
        </div>
    )
}
